import React, { useContext } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { SetStateAction } from "react";
import { SchoolID, SchoolType } from "../../editing_planning/data_requirements";
import { handleSchoolSelection } from "../mapping/map/eventHandlers";
import { useMapContextStore } from "../../context/MapContext";
import { PageContext } from "../../context/PageContext";

interface MultiSelectModalProps {
  showMultiSchoolModal: {
    sch_level: SchoolType;
    sch_id: SchoolID;
    fac_id: string;
    sch_name: string;
  }[];
  setShowMultiSchoolModal: React.Dispatch<
    SetStateAction<
      | {
          sch_level: SchoolType;
          sch_id: SchoolID;
          fac_id: string;
          sch_name: string;
        }[]
      | null
    >
  >;
}

const modalStyle = {
  position: "absolute",
  gap: 0.5,
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  width: { xs: "85%", md: 600 },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  p: 4,
};

export const MultiSelectModal: React.FC<MultiSelectModalProps> = ({
  showMultiSchoolModal,
  setShowMultiSchoolModal,
}) => {
  const content = useContext(PageContext);
  const { level } = useMapContextStore();
  return (
    <Modal
      open={showMultiSchoolModal != null}
      onClose={() => setShowMultiSchoolModal(null)}
    >
      <Box sx={modalStyle}>
        <Typography>{content.whichSchool}</Typography>
        {showMultiSchoolModal?.map((schoolItem, index) => (
          <Button
            key={index}
            variant="outlined"
            onClick={() => {
              handleSchoolSelection({ ...schoolItem, sch_level: level });
              setShowMultiSchoolModal(null);
            }}
          >
            {schoolItem.sch_name}
          </Button>
        ))}
      </Box>
    </Modal>
  );
};
